import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgChartsModule } from 'ng2-charts';

import { SharedModule } from '../../shared/shared.module';
import { CoreUiModule } from '@isophi/core-ui';
import { RecommendationsRoutingModule } from './recommendations-routing.module';
import { RecommendationsComponent } from './pages/recommendations/recommendations.component';
import { RecommendationsCardsComponent } from './components/recommendations-cards/recommendations-cards.component';

@NgModule({
  imports: [CommonModule, RecommendationsRoutingModule, SharedModule, NgChartsModule, CoreUiModule],
  declarations: [RecommendationsComponent, RecommendationsCardsComponent],
  exports: [RecommendationsComponent, RecommendationsCardsComponent],
})
export class RecommendationsModule {}
